module.exports = __webpack_public_path__ + "static/img/spumantiOmbra.9b0e3a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/products/spumantiOmbra.jpg
// module id = Joun
// module chunks = 1